import { motion } from "framer-motion";
import { ArrowUpRight, GraduationCap } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

const COPY = {
  es: {
    eyebrow: "KNDLA / CLASES",
    title: "Aprende idiomas. A tu ritmo.",
    status: "PRÓXIMAMENTE",
    description:
      "Estamos preparando nuestras próximas clases de idiomas. Muy pronto compartiremos profesores, horarios y novedades.",
    note: "Mientras tanto, descubre nuestros Speaking Clubs.",
    discover: "Ver Speaking Clubs",
  },
  en: {
    eyebrow: "KNDLA / CLASSES",
    title: "Languages. Your way.",
    status: "COMING SOON",
    description:
      "We're preparing our upcoming language classes. Teachers, schedules and details will be announced soon.",
    note: "In the meantime, explore our Speaking Clubs.",
    discover: "Explore Speaking Clubs",
  },
  ru: {
    eyebrow: "KNDLA / ЗАНЯТИЯ",
    title: "Языки в твоём ритме.",
    status: "СКОРО",
    description:
      "Мы готовим новые языковые занятия. Скоро расскажем о преподавателях, расписании и других подробностях.",
    note: "А пока загляни в наши разговорные клубы.",
    discover: "Разговорные клубы",
  },
};

export default function ClassesComingSoon() {
  const { locale } = useLang();
  const lang = String(locale || "en").toLowerCase().split("-")[0];
  const c = COPY[lang] || COPY.en;

  return (
    <section
      id="classes"
      data-testid="classes-section"
      className="relative mx-auto max-w-7xl scroll-mt-24 overflow-hidden px-5 py-24 md:px-8 md:py-36"
    >
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
      >
        <p className="text-xs font-bold uppercase tracking-[0.35em] text-flame">
          {c.eyebrow}
        </p>
        <h2 className="mt-3 font-syne text-4xl font-extrabold tracking-tighter text-white sm:text-5xl lg:text-6xl">
          {c.title}
        </h2>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-70px" }}
        transition={{ duration: 0.7, delay: 0.1 }}
        className="relative mt-12 overflow-hidden rounded-2xl border border-white/10 bg-ash p-8 sm:p-12 md:p-16"
      >
        <div
          aria-hidden="true"
          className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-flame/10 blur-3xl"
        />
        <div className="relative z-10 flex max-w-2xl flex-col items-start">
          <div className="mb-7 grid h-14 w-14 place-items-center rounded-2xl border border-flame/25 bg-flame/10 text-flame">
            <GraduationCap className="h-7 w-7" />
          </div>
          <span className="rounded-full border border-flame/40 bg-flame/10 px-4 py-1.5 text-xs font-extrabold uppercase tracking-[0.2em] text-flame">
            {c.status}
          </span>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-white/65 sm:text-lg">
            {c.description}
          </p>
          <p className="mt-7 text-sm text-white/45">{c.note}</p>
          <a
            href="#clubs"
            className="mt-4 inline-flex items-center gap-2 rounded-full border border-white/20 px-5 py-2.5 text-sm font-bold text-white transition-colors hover:border-flame hover:text-flame"
          >
            {c.discover}
            <ArrowUpRight className="h-4 w-4" />
          </a>
        </div>
      </motion.div>
    </section>
  );
}
